import {call, put, takeLatest} from "redux-saga/effects";
import {checkPermission} from "../../../utils/Authorization/authorization";
import {API} from "../../../api/api";
import {hallsAPI} from "../api/api";
import {HallsActionTypes} from "../actions/actionTypes";
import {ToasterService} from "../../../services/toaster/toaster.service";

function* getSpecificationActivity(action) {
    try {
        let activity = yield call(() =>
            hallsAPI.getSpecificationActivity({
                page: action.payload.page,
                top: action.payload.top,
                serverId: action.payload.serverId
            })
        );

        yield put({
            type: HallsActionTypes.GET_SPECIFICATION_ACTIVITY_SUCCESS,
            payload: {
                activities: activity.data.results,
                serverId: action.payload.serverId
            }
        });
    } catch (e) {
        API.handleError(e.response);

        yield put({
            type: HallsActionTypes.GET_SPECIFICATION_ACTIVITY_FAIL,
            message: e.message
        });
    }
}

export function* getSpecificationActivityWatcher() {
    yield takeLatest(
        HallsActionTypes.GET_SPECIFICATION_ACTIVITY,
        getSpecificationActivity
    );
}

function* uploadSystemSpecification(action) {
    try {
        const specification = yield call(() =>
            hallsAPI.uploadSpecification({
                serverId: action.payload.serverId,
                file: action.payload.file
            })
        );

        yield put({
            type: HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION_SUCCESS,
            payload: {
                spec: specification.data
            }
        });

        if (checkPermission("spec_history")) {
            yield put({
                type: HallsActionTypes.GET_SPECIFICATION_ACTIVITY,
                payload: {
                    page: 0,
                    top: 12,
                    serverId: action.payload.serverId
                }
            });
        }
        ToasterService.successToast(
            "System Specification Successfully uploaded."
        );
    } catch
        (e) {
        API.handleError(e.response, "Error uploading System Specification.");

        yield put({
            type: HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION_FAIL,
            message: e.message
        });
    }
}

export function* uploadSpecificationWatcher() {
    yield takeLatest(
        HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION,
        uploadSystemSpecification
    );
}
